<template lang="html">

  <section :class="['pe_cluelist', direction]">
    <header>
      <h2 class="pe_direction">{{ direction }}</h2>

      <!--<Arrow :direction="{'right': direction === 'across'}" />-->

    </header>

    <div class="pe_clues">
      <ul 
        :class="['pe_scroller', 
          {'pe_current-direction': this.isAcross && direction === 'across' || !this.isAcross && direction === 'down'
        }]"
        ref="scroller"
      >
        <Clue
          v-for="(clue, i) in clues"
          :key="`clue-${i}`"
          :clue="clue"
          :direction="direction"
          v-if="clue.direction === direction"
          @scroll-to="scrollTo"
        />

      </ul>
    </div>
  </section>

</template>

<script lang="js">

  import { mapState, mapGetters, mapActions } from 'vuex'
  import Clue from './Clue'
  import Arrow from '@puzzleapps/shared/src/components/ui/icons/Arrow'
  import animateScrollTo from 'animated-scroll-to'

  // import 

  export default  {
    name: 'cluelist',
    props: ['initialDirection'], // across, down

    components: {
      Clue,      
      Arrow
    },

    data() {
      return {
        direction: this.initialDirection,
      }
    },

    methods: {
      scrollTo(e) {
        animateScrollTo(e, {
          cancelOnUserAction: false,
          elementToScroll: this.$refs.scroller,
        })
      }
    },

    computed: {
      ...mapState({
        clues: state => state.cluelist.clues,
        isAcross: state => state.grid.isAcross,

      }),

    }

  }
</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .pe_cluelist {
    border: 2px solid #ececec;
    width: 20%;
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    height: auto;
    background: var(--secondary-background-color);
    
    header {
      display: flex;
      justify-content: space-between;
      position: relative;
      border-bottom: 1px solid #e72a11;
      align-items: center;

      .pe_arrow {
        opacity: 0.7;
        width: 20px;
        margin-right: 0.7em;
      }
    }

    &.pe_down {
      header {
        svg {
          transform: rotate(90deg);
        }
      }
    }

    .pe_direction {
      margin: 0;
      text-transform: uppercase;
      font-size: 1.1em;
      font-weight: 700;
      letter-spacing: 1px;
      padding: 0.75em;
      text-align: left;

      @media (max-width: $max-container-size) {
        font-size: 1em;
        padding: 0.5em;
      }
    }

    .pe_clues {
      position: relative;
      flex: 1;
      overflow: hidden;    
    }

    .pe_scroller {
      width: 100%;
      flex: 1;
      overflow: hidden;
      overflow-y: auto;

      &.pe_current-direction {
        li.pe_selected {
          background: #ffecca!important;//var(--cell-selected-group-color)!important;
        }
      }

      li {
        cursor: pointer;
        &.pe_selected {
          background: #ececec
        }

        &:hover {
          background: #f5f5f5;
        }
      }
    }
  }
</style>
